import classNames from 'classnames';
import React, { Children } from 'react';

type Props = {
  className?: string;
  onClear?: () => void;
  children?: React.ReactNode;
};

const FilterBar: React.FC<Props> = ({ children, className }) => {
  const visible =
    Children.toArray(children).filter(React.isValidElement).length > 0;

  if (!visible) return null;

  return (
    <div
      className={classNames(
        'flex flex-row items-center',
        'overflow-x-auto no-scrollbar md:flex-wrap md:overflow-x-hidden',
        'gap-3 px-[var(--padding)] py-1',
        className,
      )}
      style={
        {
          '--padding':
            'calc(50% - (var(--website-max-width) / 2) + var(--website-paddings))',
        } as React.CSSProperties
      }
    >
      {children}
    </div>
  );
};

export default FilterBar;
